var bundlePrice1 = ["$223.00", "$157.00", "Save 30%"]
var bundlePrice2 = ["$299.50", "$210.00", "Save 30%"]
var bundlePrice3 = ["$347.50", "$240.00", "Save 31%"]

var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){
jQuery('.subtotal-product').eq(0).before(jQuery('.t4s-quantity-wrapper.t4s-product-form__qty').eq(0));
   jQuery('.t4s-product__info-wrapper .t4s-product-tabs-wrapper').eq(0).after(jQuery('[id*="t4s-trust_seal"]').eq(0))
    if(jQuery('.fh-buyNow').length == 0){
     jQuery('.t4s-product-form__submit').eq(0).after(jQuery('<div class="fh-buyNow">BUY NOW</div>'));
 }

  jQuery('.fh-buyNow').click(function(){
    checkout();
   function checkout() {
    var url = window.location.href;
    var storeLink = url.split('.com')[0] + '.com';

    var pageSrc = document.documentElement.innerHTML;
    if (url.includes('variant=')) {

        var variantId = url.split('?variant=')[1];
    } else {
        
        var variantId = jQuery('form[action="/cart/add"] [name="id"]').val()
    }

    var qty = $('input.t4s-quantity-input[type=number]').val();

    var checkoutLink = storeLink + '/cart/' + variantId + ':' + qty + '?checkout';

    window.location.href = checkoutLink;

} 
  });
}); 
}





var ur = window.location.href;
if(ur.includes('/product')){
  
 jQuery(document).ready(function(){

   $('#atc-quantity').click(function(){
  window.location.href= "/cart/add?id=42439882277123&quantity=" + $('input#quantityselector-bundle').val()
}); 
   
    
Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};

var badgeTexts = window.productPagePoints;
    
var popup = ["guarantee-popup", "simple-shipping",   "simple-return"];
var imgSrcs = ['https://cdn.shopify.com/s/files/1/2625/5272/files/Group_11.png?v=1730382316',
              'https://cdn.shopify.com/s/files/1/2625/5272/files/Group_9_1.png?v=1730382316',
              'https://cdn.shopify.com/s/files/1/2625/5272/files/Group_13.png?v=1730382316']
var container = document.createElement('div');
container.className = 'simple-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'simple-img-container';
var y = document.querySelectorAll('.fh-buyNow')[0].parentNode;
if(document.getElementsByClassName('simple-img-container').length == 0){
 
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  var prodName = jQuery('h1.product_name').html();
  
  
}
   var svv = `
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_17_1076" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
<rect width="18" height="18" fill="#464D60"/>
</mask>
<g mask="url(#mask0_17_1076)">
<path d="M8.25006 12.75H9.75006V8.25H8.25006V12.75ZM9.00006 6.75C9.21256 6.75 9.39069 6.67812 9.53444 6.53438C9.67819 6.39062 9.75006 6.2125 9.75006 6C9.75006 5.7875 9.67819 5.60938 9.53444 5.46562C9.39069 5.32187 9.21256 5.25 9.00006 5.25C8.78756 5.25 8.60944 5.32187 8.46569 5.46562C8.32194 5.60938 8.25006 5.7875 8.25006 6C8.25006 6.2125 8.32194 6.39062 8.46569 6.53438C8.60944 6.67812 8.78756 6.75 9.00006 6.75ZM9.00006 16.5C7.96256 16.5 6.98756 16.3031 6.07506 15.9094C5.16256 15.5156 4.36881 14.9813 3.69381 14.3063C3.01881 13.6313 2.48444 12.8375 2.09069 11.925C1.69694 11.0125 1.50006 10.0375 1.50006 9C1.50006 7.9625 1.69694 6.9875 2.09069 6.075C2.48444 5.1625 3.01881 4.36875 3.69381 3.69375C4.36881 3.01875 5.16256 2.48438 6.07506 2.09063C6.98756 1.69687 7.96256 1.5 9.00006 1.5C10.0376 1.5 11.0126 1.69687 11.9251 2.09063C12.8376 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5157 5.1625 15.9094 6.075C16.3032 6.9875 16.5001 7.9625 16.5001 9C16.5001 10.0375 16.3032 11.0125 15.9094 11.925C15.5157 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8376 15.5156 11.9251 15.9094C11.0126 16.3031 10.0376 16.5 9.00006 16.5ZM9.00006 15C10.6751 15 12.0938 14.4187 13.2563 13.2563C14.4188 12.0938 15.0001 10.675 15.0001 9C15.0001 7.325 14.4188 5.90625 13.2563 4.74375C12.0938 3.58125 10.6751 3 9.00006 3C7.32506 3 5.90631 3.58125 4.74381 4.74375C3.58131 5.90625 3.00006 7.325 3.00006 9C3.00006 10.675 3.58131 12.0938 4.74381 13.2563C5.90631 14.4187 7.32506 15 9.00006 15Z" fill="#464D60"/>
</g>
</svg>
`;
if(badgeTexts.length){
for(var i = 0; i < imgSrcs.length; i++){
       if (badgeTexts[i] && badgeTexts[i].trim() !== "") {             
    var img = document.createElement('div');
    img.innerHTML = '<div class="ah simple-badge-container"><img src="'+imgSrcs[i]+'"><span class="badge'+i+'" id="'+popup[i]+'">'+badgeTexts[i]+ svv + '</span></div>';

    imgContainer.appendChild(img);
    img.className = "simple-badges-container";
           
    
}
}
}
});
  
  
jQuery(document).ready(function(){
 var atc = 0; var timeratc = setInterval(function(){
  if(jQuery('.simple-badges').length == 0) {
  var cont = jQuery('#guarantee').html();
  jQuery('body').append(jQuery(`<div class="simple-popup guarantee-popup">
  <div class="popup-content">
    <div class="popup-title">  <span class="simple-close">×</span></div>
    <div class="popup-p">
          <div class="popup-contentt">
      `+cont+`
      </div>
    </div>

  </div>
</div>`))
      
  var cont = jQuery('#shipping-p').html();
  jQuery('body').append(jQuery(`<div class="simple-popup simple-shipping-popup">
  <div class="popup-content">
    <div class="popup-title"> <span class="simple-close">×</span></div>
    <div class="popup-p">
      <div class="popup-contentt">
      `+cont+`
      </div>
    </div>
  </div>
</div>`))
  
var cont = jQuery('#returns-p').html()
     jQuery('body').append(jQuery(`<div class="simple-popup simple-return-popup">
  <div class="popup-content">
    <div class="popup-title"> <span class="simple-close">×</span></div>
    <div class="popup-p">
      <div class="popup-contentt">
      `+cont+`
      </div>
    </div>
  </div>
</div>`))
    jQuery('#guarantee-popup').click(function(e){
  e.stopPropagation();
  jQuery('.guarantee-popup').eq(0).addClass('open')

  });  
  jQuery('#simple-shipping').click(function(e){
  e.stopPropagation();
  jQuery('.simple-shipping-popup').eq(0).addClass('open')

  });   
  
        jQuery('#simple-return').click(function(e){
  e.stopPropagation();
  jQuery('.simple-return-popup').eq(0).addClass('open')
  });   
 jQuery('span.simple-close').click(function(){
  jQuery(this).parent().parent().parent().removeClass('open')
}); 
    
    jQuery('.simple-popup').click(function(event){
  event.stopPropagation();
});
   jQuery(window).click(function() {
     if(jQuery('body > .open').length){
       jQuery('span.simple-close').click();
  jQuery('.product_infos').removeClass('show-popup');
     }
  
});
clearInterval(timeratc);}if( atc > 200){clearInterval(timeratc);}atc++;}, 50);
});    
  
}




var ur = window.location.href;
if(ur.includes('/product')){
jQuery(document).ready(function(){
    
  var btnClass = "button.t4s-product-form__submit";
  var prodTitle = "h1.t4s-product__title";
  var prodPrice = ".subtotal-product";

    
  Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-cont"><div class="simple-product-name"><p></p><div class="st-reviews"></div></div></div> <div class="simple-st-container__inner"><div class="simple-st-item_column__button"><div class="simple-product-price"></div><a class="simple-st-item__button" rel="nofollow">Add to Cart</a></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('simple-st-container').length == 0){
  y[0].appendChild(sticky);
  
  
jQuery('.simple-product-name p').html(jQuery(prodTitle).eq(0).html());
 setTimeout(function(){ 
jQuery('.st-reviews').eq(0).append(jQuery('.loox-rating.product-review-dv').eq(0).clone())
}, 2000);
 

  
  jQuery('.simple-st-item__button').click(function(){
    window.scrollTo({
        top: jQuery('h1').eq(0).offset().top,
        behavior: 'smooth'
    });
    
   
  });
  
 
    
};

       
var mc = window.matchMedia("(min-width: 767px)");
        
        
    var elem = document.getElementById("simple-st-containerID");      
    function slideShow() {
          jQuery('body').addClass('simple-sticky');
    }
          		
     function slideHide() {    
        jQuery('body').removeClass('simple-sticky');
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery(btnClass).eq(0).offset().top) {
       slideShow();
            
    } else {
  
        slideHide();
        
    }
});   
});                             
}





document.addEventListener("DOMContentLoaded", function() {
  document.querySelector('.t4s-accordion-style-1 h3.t4s-section-title.t4s-title').innerHTML = 'Frequently Asked Questions';
});







document.addEventListener('DOMContentLoaded', function () {
    // Limit to main product media wrapper
    var mediaWrapper = document.querySelector('.t4s-product__media-wrapper');
    if (!mediaWrapper) return;

    // For multi-media layout:
    var row = mediaWrapper.querySelector(':scope > .t4s-row.t4s-g-0');

    // For single-media layout:
    var singleMedia = mediaWrapper.querySelector(
      ':scope > [data-product-single-media-group].t4s-product__one_media.t4s-pr'
    );

    // Choose whichever exists (prefer row if both, just in case)
    var mainMediaGroup = row || singleMedia;
    if (!mainMediaGroup) return; // nothing to wrap

    // Find optional extras we also want to keep sticky
    var loox  = mediaWrapper.querySelector(':scope > .looxdiv');
    var levar = mediaWrapper.querySelector(':scope > [data-levar-activations]');

    // Create new sticky container
    var stickyContainer = document.createElement('div');
    stickyContainer.className = 'rr-sticky-media-container';

    // Insert before the main media group
    mediaWrapper.insertBefore(stickyContainer, mainMediaGroup);

    // Move elements into sticky container, preserving order
    stickyContainer.appendChild(mainMediaGroup);
    if (loox)  stickyContainer.appendChild(loox);
    if (levar) stickyContainer.appendChild(levar);
  });


  (function () {
  // --- MOBILE CHECK: Exit if screen is wider than 768px ---
  if (window.innerWidth > 768) return;

  function initQuantityExperiment() {
    var productButtons = document.querySelector('.wd.t4s-product-form__buttons');
    if (!productButtons) return;

    // --- 1) Get discount value from badge ---
    var badge = document.querySelector('span.ch.t4s-badge-price');
    var discountText = badge ? badge.textContent.trim() : '';
    var match = discountText.match(/(\d+%)/);
    var discountValue = match ? match[1] : '20%';

    // --- 2) PREPEND banner ---
    if (!document.querySelector('.quantity-discount-banner')) {
      var banner = document.createElement('div');
      banner.className = 'quantity-discount-banner';
      banner.innerHTML =
        'Enjoy <span class="qdb-main">' +
        discountValue +
        ' OFF</span> — ' +
        '<span class="qdb-sub">plus extra savings when you buy more!</span>';
      productButtons.insertBefore(banner, productButtons.firstChild);
    }

    // --- Helper: always use <span class="quantitydiscountpercent"> ---
    function setMessage(labelSelector, message, idSuffix) {
      var label = document.querySelector(labelSelector);
      if (!label) return;

      var unitPrice = label.querySelector('.unit-price');
      if (!unitPrice) return;

      var existing = label.querySelector('.quantitydiscountpercent');
      var msg;

      // If there is an existing element and it's NOT a span, remove it
      if (existing && existing.tagName !== 'SPAN') {
        existing.parentNode.removeChild(existing);
        existing = null;
      }

      if (existing) {
        msg = existing;
      } else {
        msg = document.createElement('span');
        msg.className = 'quantitydiscountpercent';
        unitPrice.insertAdjacentElement('afterend', msg);
      }

      msg.id = 'quantitydiscountpercent' + idSuffix;
      msg.textContent = message;
    }

    // --- 3) Apply messages ---
    setMessage('label.quantity1', 'Save ' + discountValue, '1');
    setMessage('label.quantity2', 'Additional 5% Off', '2');
    setMessage('label.quantity3', 'Additional 10% Off', '3');
  }

  var attempts = 0;
  var timer = setInterval(function () {
    attempts++;
    if (document.querySelector('.wd.t4s-product-form__buttons')) {
      clearInterval(timer);
      initQuantityExperiment();
    } else if (attempts >= 40) {
      clearInterval(timer);
    }
  }, 300);
})();




/* Variation Code - Convert.com */

// 1. Utility function to wait for elements to exist
// Updated to accept multiple selectors separated by commas
function waitForElements(selector, callback) {
  const interval = setInterval(function() {
    if (document.querySelector(selector)) {
      clearInterval(interval);
      callback();
    }
  }, 50);

  setTimeout(function() { clearInterval(interval); }, 5000);
}

// 2. Define the move logic
function moveBadges() {
    const description = document.querySelector('.t4s-product__description.t4s-rte');
    
    // Check for both potential selectors
    const badges = document.querySelector('.rr-badges, .simple-badges-outer-container');

    if (description && badges) {
        // Move whichever badge container was found after the description
        description.after(badges);
        
        // Apply styling to the badge container
        badges.style.marginTop = '15px'; 
        badges.style.display = 'block'; // Ensures visibility if hidden by default
    }
}

// 3. Run the check
// We wait for either .rr-badges OR .simple-badges-outer-container
waitForElements('.rr-badges, .simple-badges-outer-container', moveBadges);